import { render, staticRenderFns } from "./ResetPasswordToken.vue?vue&type=template&id=01ca543e&scoped=true"
import script from "./ResetPasswordToken.vue?vue&type=script&lang=js"
export * from "./ResetPasswordToken.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordToken.vue?vue&type=style&index=0&id=01ca543e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca543e",
  null
  
)

export default component.exports